/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Payout_Total_LifetimeInputs */



/**
* | output |
* | --- |
* | "Payable · all quarters" |
*
* @param {Partner_Payout_Total_LifetimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_total_lifetime = /** @type {((inputs?: Partner_Payout_Total_LifetimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Total_LifetimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auszahlbar · alle Quartale")
	return /** @type {LocalizedString} */ ("Payable · all quarters")
});